interface type {
    value:string,
    viewValue:string,
    viewValue1?:string,
    viewValue2?:string,
}
export const presenceTypes: type[] = [
    { value: 'In_Person', viewValue: 'حضوری' },
    { value: 'Remote_Working', viewValue: 'دورکاری' },
    { value: 'Combined', viewValue: 'ترکیبی' },
]

export const activitiesTypes: type[] = [
    { value: 'full_time', viewValue: 'تمام وقت' },
    { value: 'part_time', viewValue: 'پاره وقت' },
    { value: 'intership', viewValue: 'کارآموزی' },
    { value: 'medical_intership', viewValue: 'کارورزی' },
    { value: 'self_employee', viewValue: 'خوداشتغالی' },
    { value: 'freelancer', viewValue: 'فریلنسری' }
]

export const perHourTypes: type[] = [
    { value: 'Per_Hour', viewValue: 'ساعتی' },
    { value: 'Per_Month', viewValue: 'ماهانه' },
]

export const maritalTypes: type[] = [
    { value: 'SINGLE', viewValue: 'مجرد' },
    { value: 'MARRIED', viewValue: 'متأهل' },
]

export const currencyTypes: type[] = [
    { value: 'IRT', viewValue: 'تومان' },
    { value: 'USD', viewValue: 'دلار' },
    { value: 'EUR', viewValue: 'یورو' },
]

export const organRrank: type[] = [
    { value: "Senior_Manager", viewValue: 'مدیرارشد' },
    { value: "Assistant_Manager", viewValue: 'معاونت' },
    { value: "Middle_Manager", viewValue: 'مدیر میانی' },
    { value: "Senior_Expert", viewValue: 'کارشناس ارشد' },
    { value: "Expert", viewValue: 'کارشناس' },
    { value: "Employee", viewValue: 'کارمند' },
    { value: "Worker", viewValue: 'کارگر' }
]

export const genderType: type[] = [
    {value:'FEMALE' , viewValue:'خانم'},
    {value:'MALE' , viewValue:'آقا'},
    {value:'BOTHGENDER' , viewValue:'تفاوتی ندارد'},
]

export const militeryServiceType: type[] = [
    {viewValue:'پایان خدمت', value:'end_of_service'},
    {viewValue:'معاف دائم', value:'exemption'},
    {viewValue:'معافیت تحصیلی', value:'educational_exemption'},
    {viewValue:'در حال انجام', value:'in_service'},
    {viewValue:'مشمول', value:'subject_to_service'},
    {viewValue:'غیرمشمول', value:'none'},
]

export const eduGradesType: type[] = [
    {viewValue:'کاردانی', value:'associate'},
    {viewValue:'کارشناسی', value:'bachelors'},
    {viewValue:'کارشناسی ارشد', value:'masters'},
    {viewValue:'کارشناسی ارشد پیوسته', value:'continuous_masters'},
    {viewValue:'دکترای پیوسته', value:'continuous_phd'},
    {viewValue:'دکترای عمومی', value:'docterate'},
    {viewValue:'دکترای تخصصی', value:'phd'},
    {viewValue:'پسادکتری', value:'postdoc'},
    {viewValue:'حوزوی', value:'clergic'},
]

export const profileRequiredData: type[] = [
    { value: "GENDER", viewValue: 'جنسیت' },
    { value: "MILITARY_SERVICE_STATUS", viewValue: 'وضعیت نظام وظیفه' },
    { value: "YEAR_OF_BIRTH", viewValue: 'سال تولد',viewValue1:'تاریخ تولد',viewValue2:'سن' },
    { value: "NATIONAL_ID", viewValue: 'کدملی' },
    { value: "CITY", viewValue: 'محل سکونت',viewValue1:'موقعیت مکانی' },
    { value: "MARITAL_STATUS", viewValue: 'وضعیت تأهل' },
    { value: "EMPLOYEE", viewValue: 'سابقه کاری' , viewValue1:'تجربه کاری' },
    { value: "STUDENT", viewValue: 'سوابق تحصیلی' , viewValue1:'تحصیلات' },
    { value: "CERTIFICATION", viewValue: 'دوره آموزشی',viewValue1:'گواهی' },
    { value: "AWARD", viewValue: 'جوایز و افتخارات',viewValue1:'دستاوردها' },
    { value: "LANGUAGE_SKILL", viewValue: 'مهارت زبان' },
    { value: "SOFTWARE_SKILL", viewValue: 'مهارت نرم افزاری' },
    { value: "SKILL", viewValue: 'مهارت تکمیلی', viewValue1:'سایر مهارت ها'},
    { value: "PROJECT", viewValue: 'پروژه علمی '},
    { value: "BOOK", viewValue: 'کتاب و مقالات' },
    { value: "VOLUNTARY_ACTIVITY", viewValue: 'فعالیت های داوطلبانه' },
]
